import React, { useState, useEffect, useCallback, useRef } from "react";
import useAppContext from "../../../utils/Reducers";
import ButtonBar from "../../../components/Layout/ButtonBar";
import SearchBar from "./SearchBar";
import { useAxiosWithAuthorization } from "../../../utils/api";
import { ModalConfirm } from "../../../components/Confirm";
import { columnLayout } from "./columnLayout";
import { defaultGridProps } from "../../../components/AuiGrid/gridLayout";
import {
  setStorageItem,
  getStorageItem,
} from "../../../hooks/Storage/useLocalStorage";
import moment from "moment";
import AUIGrid from "../../../lib/AuiGrid/AUIGridReact";
import { ModalCameraRecordPop } from "../../Popup/CameraRecordPop";
import { ModalCameraSnapshotPop } from "../../Popup/CameraSnapshotPop";

//전송버튼을 클릭했을경우 함수가 외부에서 호출하여 primaryParameters 아무값도 들어가 있지 않음
//그래서 플래그를 두어 sendCnt값이 변경되면 useEffect에서 검색버튼의 함수를 실행시킴
var sendCnt = 0;

const ScrapDailyTotal = (props) => {
  var footerLayout = [
    {
      labelText: "합계",
      positionField: "#base",
    },
    {
      dataField: "inspno",
      positionField: "inspno",
      operation: "COUNT",
      formatString: "#,##0",
      style: "aui-grid-my-header-sum-total",
    },

    {
      dataField: "inweight",
      positionField: "inweight",
      operation: "SUM",
      formatString: "#,##0",
      style: "aui-grid-my-header-sum-total",
    },
    {
      dataField: "outweight",
      positionField: "outweight",
      operation: "SUM",
      formatString: "#,##0",
      style: "aui-grid-my-header-sum-total",
    },
    {
      dataField: "outagewght",
      positionField: "outagewght",
      operation: "SUM",
      formatString: "#,##0",
      style: "aui-grid-my-header-sum-total",
    },
    {
      dataField: "realweight",
      positionField: "realweight",
      operation: "SUM",
      formatString: "#,##0",
      style: "aui-grid-my-header-sum-total",
    },
    {
      dataField: "totalweight",
      positionField: "totalweight",
      operation: "SUM",
      formatString: "#,##0",
      style: "aui-grid-my-header-sum-total",
    },
  ];

  const myGrid = useRef();
  const [research, setResearch] = useState(0);

  const {
    store: { userInfo, menuKey },
  } = useAppContext();

  useEffect(() => {
    const auiGrid = myGrid.current;
    auiGrid.resize("100%", 600);
  }, [menuKey]);

  const [searchParameters, setSearchParameters] = useState({
    schPlantCd: "",
    schvndrNm: "",
    schVhclNo: "",
    schOdrType: "",
    schSinspDt: moment().format("YYYY-MM-DD"),
    schEinspDt: moment().format("YYYY-MM-DD"),
  });

  const initItem = {
    realweight: "",
    outageweight: "",
    totalcnt: "",
    outagecnt: "",
    returncnt: "",
    outagerate: "",
    returnrate: "",
  };

  const [fieldValues, setFieldValues] = useState(initItem);

  const SEARCH_SCRAPDAILY_LIST_URL =
    "/domesticscrap/searchScrapDailTotalList.do";

  const SEARCH_SCRAPDAILY_COUNT_URL =
    "/domesticscrap/searchScrapDailTotalCount.do";

  const [, fetchData] = useAxiosWithAuthorization(
    {
      url: SEARCH_SCRAPDAILY_LIST_URL,
    },
    { manual: true }
  );

  //코드 및 그리드 초기화 및 생성
  useEffect(() => {
    if (research !== 0) {
      handleMasterSearch();
    }
  }, [research]);

  useEffect(() => {
    const auiGrid = myGrid.current;
    auiGrid.setFooter(footerLayout);
    //Local Storage에 저장된 그리드 컬럼 정렬정보를 가져옴
    const columnList = getStorageItem(props.menuInfo.menuId, "");
    if (columnList !== "") {
      auiGrid.setColumnOrder(columnList);
    }
    const columnSize = getStorageItem(props.menuInfo.menuId + "_s", "");
    if (columnSize !== "") {
      //Local Storage에 저장된 그리드 컬럼 Width 정보를 가져옴
      auiGrid.setColumnSizeList(columnSize);
    }
  }, []);

  //그리드 정렬 저장
  const handleGridSorting = useCallback(() => {
    const auiGrid = myGrid.current;
    const items = auiGrid.getColumnInfoList();
    let columnList = [];
    let columnSize = [];
    items.forEach((item) => {
      columnList.push(item.dataField);
      columnSize.push(item.width);
    });
    setStorageItem(props.menuInfo.menuId, columnList);
    setStorageItem(props.menuInfo.menuId + "_s", columnSize);
    ModalConfirm({
      title: "그리드 정렬 저장",
      description: "그리드 정렬을 저장하였습니다. ",
    });
  });

  const handleMasterExcel = useCallback(() => {
    const auiGrid = myGrid.current;
    auiGrid.exportToXlsx({
      fileName: props.menuInfo.menuNmKor + " 리스트",
      exceptColumnFields: auiGrid.getHiddenColumnDataFields(),
    });
  });

  const handleMasterSearch = async () => {
    const auiGrid = myGrid.current;
    auiGrid.showAjaxLoader();
    const {
      data: { data },
    } = await fetchData({
      url: SEARCH_SCRAPDAILY_LIST_URL,
      params: searchParameters,
    });
    auiGrid.setGridData(data);

    const response = await fetchData({
      url: SEARCH_SCRAPDAILY_COUNT_URL,
      params: searchParameters,
    });
    const count = response.data.data[0];
    //console.log(response.data.data[0]);
    setFieldValues({
      realweight: count.realweight,
      outageweight: count.outageweight,
      totalcnt: count.totalcnt,
      outagecnt: count.outagecnt,
      returncnt: count.returncnt,
      outagerate: count.outagerate,
      returnrate: count.returnrate,
    });

    auiGrid.removeAjaxLoader();
  };
  const popCameraRecord = useCallback(async (event) => {
    //console.log(event);
    ModalCameraRecordPop({ inspNo: event.item.inspno });
  });

  const popSnapshot = useCallback(async (event) => {
    //console.log(event);
    ModalCameraSnapshotPop({
      inspNo: event.item.inspno,
      scrapAreaCd: event.item.scrapAreaCd,
    });
  });

  //그리드 정렬 취소
  const handleGridSortingCancel = useCallback(() => {
    const auiGrid = myGrid.current;
    setStorageItem(props.menuInfo.menuId, "");
    var colLayout = columnLayout(popCameraRecord, popSnapshot);
    auiGrid.changeColumnLayout(colLayout);
    ModalConfirm({
      title: "그리드 정렬 취소",
      description: "그리드 정렬을 취소하였습니다. ",
    });
  });

  return (
    <>
      <ButtonBar
        menuInfo={props.menuInfo}
        handleMasterSearch={handleMasterSearch}
        handleMasterExcel={handleMasterExcel}
        isGridSort={true}
        handleGridSorting={handleGridSorting}
        handleGridSortingCancel={handleGridSortingCancel}
      />
      <SearchBar
        setSearchParameters={setSearchParameters}
        searchParameters={searchParameters}
      />

      <table className="t_garo">
        <tr>
          <td> 입고중량({fieldValues.realweight}kg)</td>
          <td> 감량({fieldValues.outageweight}kg)</td>
          <td> 감량율({fieldValues.outagerate}%)</td>
          <td> 총차량수({fieldValues.totalcnt}대)</td>
          <td> 감량차량수({fieldValues.outagecnt}대)</td>
          <td> 반품차량수({fieldValues.returncnt}대)</td>
          <td> 반품율({fieldValues.returnrate}%)</td>
        </tr>
      </table>
      <AUIGrid
        ref={myGrid}
        columnLayout={columnLayout(popCameraRecord, popSnapshot)}
        gridProps={{
          ...defaultGridProps,
          width: "100%",
          height: 600, // 푸터 사용 여부
          showFooter: true,
          footerPosition: "top",
        }}
      />
    </>
  );
};

export default ScrapDailyTotal;
